<template>
  <div class="tw-flex tw-justify-between tw-items-center flex-shrink-0 tw-p-8 tw-border-2 tw-border-dashed tw-rounded-3xl tw-text-slate-600 tw-border-slate-600">
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-3">
      <svg-vue
        icon="icons/plus"
        class="tw-w-6 tw-h-6"
      />

      <span class="tw-text-xl tw-font-bold">
        <slot />
      </span>
    </div>
  </div>
</template>
